import type { Address } from "@jti/fe-common";
import type { IOrderAttributeOutput } from "@jti/magento";
import { AddressInfoBlock, OrderAttributesInfo } from "@jti/ui";

import { OrderDotContent } from "./OrderDotContent";

type OrderAddressesType = {
  address: Address;
  title: string;
  className: string;
  orderAttributesInfos?: IOrderAttributeOutput[];
};

export const OrderAddresses = ({ address, title, className, orderAttributesInfos }: OrderAddressesType) => {
  const { name: companyName } = address?.pickupInformation || {};

  return (
    <OrderDotContent condition={true} title={title} className={className}>
      <AddressInfoBlock
        address={address}
        hideTelephone
        isEditable={false}
        companyName={companyName}
        hideName={!!companyName}
      />
      {orderAttributesInfos && <OrderAttributesInfo orderAttributesInfos={orderAttributesInfos} />}
    </OrderDotContent>
  );
};
